"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Toast = require("@react/react-spectrum/Toast");

var _reactIntl = require("react-intl");

var _constants = require("../../constants");

var _errorToMessageMap;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var errorToMessageMap = (_errorToMessageMap = {}, _defineProperty(_errorToMessageMap, _constants.COMMENTS_GET.ERROR, 'comments.error.load'), _defineProperty(_errorToMessageMap, _constants.COMMENTS_EDIT.ERROR, 'comments.error.edit'), _defineProperty(_errorToMessageMap, _constants.COMMENTS_RESOLVE.ERROR, 'comments.error.edit'), _defineProperty(_errorToMessageMap, _constants.COMMENTS_DELETE.ERROR, 'comments.error.edit'), _defineProperty(_errorToMessageMap, _constants.COMMENTS_OPEN.ERROR, 'comments.error.edit'), _defineProperty(_errorToMessageMap, "".concat(_constants.COMMENTS_POST.ERROR, "_ROOT"), 'comments.error.post'), _defineProperty(_errorToMessageMap, "".concat(_constants.COMMENTS_POST.ERROR, "_REPLY"), 'comments.error.reply'), _errorToMessageMap);

var Error = function Error(_ref) {
  var onClose = _ref.onClose,
      errorLocation = _ref.errorLocation,
      errorType = _ref.errorType;
  var onCloseClick = (0, _react.useCallback)(function () {
    onClose(errorLocation);
  }, [onClose, errorLocation]); // This ensures
  // 1. We dont show errors to be shown in the list.
  // 2. We know what error to display

  if (errorLocation === 'list' || !errorToMessageMap[errorType]) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement(_Toast.Toast, {
    className: "comments-error",
    closable: true,
    onClose: onCloseClick,
    variant: "error"
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: errorToMessageMap[errorType]
  }));
};

Error.defaultProps = {
  onClose: function onClose() {}
};
Error.propTypes = {
  children: _propTypes.default.node,
  onClose: _propTypes.default.func,
  errorLocation: _propTypes.default.string.isRequired,
  errorType: _propTypes.default.string.isRequired
};
var _default = Error;
exports.default = _default;